import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelDynamic as _vModelDynamic, vModelText as _vModelText, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ag-form" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["onUpdate:modelValue", "required", "type", "disabled", "id"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["id", "onUpdate:modelValue", "required", "disabled", "onChange"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: "null"
}, "select an option", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = ["id", "onUpdate:modelValue", "required", "disabled", "onChange"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: "null"
}, "select an option", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  type: "submit",
  class: "ag-button_primary ag-button border-0 ag-button_radius"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_password = _resolveComponent("ag-password")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.elements, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["form-group", item.class])
        }, [
          (item.type !== 'hidden')
            ? _withDirectives((_openBlock(), _createElementBlock("label", {
                key: 0,
                for: 'ag-formEl_' + item.name
              }, [
                _createTextVNode(_toDisplayString(_ctx.t(item.label)), 1)
              ], 8, _hoisted_3)), [
                [_directive_role, item.roles],
                [_vShow, item.show != false]
              ])
            : _createCommentVNode("", true),
          (item.type == 'password')
            ? (_openBlock(), _createBlock(_component_ag_password, {
                key: 1,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                item: item
              }, null, 8, ["modelValue", "onUpdate:modelValue", "item"]))
            : _createCommentVNode("", true),
          (item.field === 'input' && item.type != 'password')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                required: item.required,
                type: item.type,
                disabled: item.disabled ? item.disabled : false,
                class: "form-control",
                id: 'ag-formEl_' + item.name
              }, null, 8, _hoisted_4)), [
                [_vModelDynamic, item.value]
              ])
            : _createCommentVNode("", true),
          (item.field === 'hidden')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 3,
                type: "hidden",
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
              }, null, 8, _hoisted_5)), [
                [_vModelText, item.value]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (item.show != false && item.field === 'companySelect')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  class: "form-control",
                  id: 'ag-formEl-_' + item.name,
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                  required: item.required,
                  disabled: item.loading,
                  onChange: ($event: any) => (item?.changeFunction(item, _ctx.options.elements))
                }, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (item, key) => {
                    return _withDirectives((_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: item.companyGuid
                    }, [
                      _createTextVNode(_toDisplayString(item.companyName), 1)
                    ], 8, _hoisted_8)), [
                      [_directive_role, item.roles]
                    ])
                  }), 128))
                ], 40, _hoisted_6)), [
                  [_vModelSelect, item.value],
                  [_directive_role, item.roles]
                ])
              : _createCommentVNode("", true),
            (item.show != false && item.field === 'select')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  class: "form-control",
                  id: 'ag-formEl-_' + item.name,
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                  required: item.required,
                  disabled: item.loading,
                  onChange: ($event: any) => (item?.changeFunction(item, _ctx.options.elements))
                }, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (item, key) => {
                    return _withDirectives((_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: item.value
                    }, [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ], 8, _hoisted_11)), [
                      [_directive_role, item.roles]
                    ])
                  }), 128))
                ], 40, _hoisted_9)), [
                  [_vModelSelect, item.value],
                  [_directive_role, item.roles]
                ])
              : _createCommentVNode("", true),
            (item.show != false && item.field === 'multiselect')
              ? _withDirectives((_openBlock(), _createBlock(_component_multiselect, {
                  key: 2,
                  modelValue: item.value,
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                  class: "form-control",
                  required: item.required,
                  disabled: item.loading,
                  options: item.options,
                  label: "label",
                  mode: item.mode || 'single',
                  searchable: true,
                  closeOnSelect: item.mode != 'multiple',
                  onClose: ($event: any) => (item?.changeFunction(item, _ctx.options.elements))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "required", "disabled", "options", "mode", "closeOnSelect", "onClose"])), [
                  [_directive_role, item.roles]
                ])
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ]),
    (_ctx.options.submitText)
      ? (_openBlock(), _createElementBlock("button", _hoisted_12, _toDisplayString(_ctx.t(_ctx.options.submitText)), 1))
      : _createCommentVNode("", true)
  ]))
}